export default "__VITE_ASSET__ZHSdqF$K__"